var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.287 9.981A2.291 2.291 0 0 1 24.9 11.6c.38 1.425.38 4.401.38 4.401s0 2.976-.38 4.401a2.291 2.291 0 0 1-1.613 1.618c-1.422.381-7.127.381-7.127.381s-5.701 0-7.126-.381a2.291 2.291 0 0 1-1.614-1.617C7.04 18.976 7.04 16 7.04 16s0-2.976.38-4.401A2.29 2.29 0 0 1 9.034 9.98c1.425-.38 7.126-.38 7.126-.38s5.705 0 7.127.38Zm-4.21 6.02-4.739 2.742v-5.486L19.077 16Z",
    fill: "currentColor"
  })));
};
export default SvgYoutube;